<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-sm-8 align-self-center">
                <div class="card mt-5 shadow" style="max-width: 500px; margin: 0 auto">
                    <div class="text-center">
                        <img class="mt-4" src="/ventisquero_smallLogo_dark.png" width="80%" alt="Viña Ventisquero">

                        <p>Procesando login...</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Post } from '../helper/axios'
//import toastr from 'toastr'

export default {
    data() {
        return {
            Post,
            isLoading: false,
            apiUrl: this.$store.getters.apiUrl + 'auth/login'
        }
    },
    mounted() {
        const code = this.$route.query.code
        if (code) {
            this.loginWithMicrosoft(code)
        } else {
            window.close()
        }
    },
    methods: {
        async loginWithMicrosoft(code) {
            try {
                const redirectUri = window.location.origin + '/microsoft-callback'
                this.Post(this.apiUrl,
                    {
                        code: code,
                        redirectUri: redirectUri
                    },
                    (res) => {
                        if (res.data?.statusCode === 200) {
                            if (window.opener) {
                                window.opener.postMessage(
                                    {
                                        type: 'MICROSOFT_LOGIN_SUCCESS',
                                        data: res.data.data
                                    },
                                    window.location.origin
                                )
                            }

                            setTimeout(() => {
                                window.close()
                            }, 1000)
                        } else {
                            window.close()
                        }
                    }
                )

            } catch (err) {
                console.error('Login error:', err)
                window.close()
            }
        }

    }
}
</script>